import { Box, Text } from '@mantine/core';
import { observer } from 'mobx-react';
import { useDisclosure } from '@mantine/hooks';
import { BaseModal } from '@web/common-ui';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { DialogIntro } from './DialogIntro';
import { Routes } from '../../../../../route/Routes';
import { useLocation } from 'react-router-dom';
import { useRepeatedQuestionnaireStore } from '../stores/RepeatedQuestionnaireStore';
import { useQuestionnaireEvaluationStore } from '../../../../../store';

export const RepeatedQuestionnaireDialog = observer(() => {
  const [opened, { open, close }] = useDisclosure(false);
  const evaluationStore = useQuestionnaireEvaluationStore();
  const location = useLocation();
  const store = useRepeatedQuestionnaireStore();
  const { t } = useTranslation('repeated-questionnaire');
  const bothFilledOut =
    store.repeatedQuestionnaireFilloutStatus.cudit &&
    store.repeatedQuestionnaireFilloutStatus.sf12;

  function onSuccess() {
    close();
    // we already show the success notification after the last questionnaire is filled out
    // the user only sees the "done" button if the studienarzt dialog is not shown
  }

  useEffect(() => {
    store.getFilloutStatus();
  }, [store, location]);

  useEffect(() => {
    // we can only show one modal at a time
    if (evaluationStore.showDialog) close();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [evaluationStore.showDialog, location]);

  useEffect(() => {
    // we only load the checklist if the user can fill them out
    if (!bothFilledOut) store.loadChecklist();
  }, [bothFilledOut, store]);

  useEffect(() => {
    const sf12Done = store.repeatedQuestionnaireFilloutStatus?.sf12;
    const cuditDone = store.repeatedQuestionnaireFilloutStatus?.cudit;
    const userNeedsToFillOutQuestionnaire = !sf12Done || !cuditDone;

    if (
      userNeedsToFillOutQuestionnaire &&
      !opened &&
      !evaluationStore.showDialog // we can only show one modal at a time
    ) {
      open();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [store.repeatedQuestionnaireFilloutStatus, evaluationStore.showDialog]);

  // we dont want to show the dialog on the questionnaire pages, so the user can fill them out
  if (
    location.pathname.includes(
      Routes.RepeatedCannabisConsumptionQuestionnaire,
    ) ||
    location.pathname.includes(Routes.RepeatedSF12Questionnaire)
  ) {
    return null;
  }

  return (
    <BaseModal
      opened={opened}
      onClose={close}
      closeOnClickOutside={false}
      title=""
      description=""
      size="500px"
      customHeader={
        <Text c="#EB0037" fw="600" size="12px" lh="32px" p="10px 0px 0px 5px">
          {t('ProjectTitle')}
        </Text>
      }
      children={
        <Box>
          <Text fw="600" lts="-0.5px" lh="25.2px" size="21px">
            {t('Title')}
          </Text>
          <DialogIntro onSuccess={onSuccess} />
        </Box>
      }
    />
  );
});
